// Custom scrollbar styles for ChatArea
export const chatAreaScrollbarStyles = `
  /* WebKit browsers (Chrome, Safari, Edge) */
  .chat-area-scrollbar::-webkit-scrollbar {
    width: 8px;
  }

  .chat-area-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }

  .chat-area-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    transition: all 0.2s ease;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  .chat-area-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.25);
  }

  /* Dark mode */
  .dark .chat-area-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.15);
  }

  .dark .chat-area-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.25);
  }

  /* Firefox */
  .chat-area-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.15) transparent;
  }

  .dark .chat-area-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
  }

  /* Smooth scrolling */
  .chat-area-scrollbar {
    scroll-behavior: smooth;
  }

  /* Hide scrollbar when not needed */
  .chat-area-scrollbar:not(:hover)::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.08);
  }

  .dark .chat-area-scrollbar:not(:hover)::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.08);
  }

  /* Ultra-thin scrollbar on hover for more Apple-like feel */
  .chat-area-scrollbar:hover::-webkit-scrollbar {
    width: 10px;
  }

  /* Textarea scrollbar styling */
  .textarea-scrollbar::-webkit-scrollbar {
    width: 6px;
  }

  .textarea-scrollbar::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 3px;
  }

  .textarea-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.12);
    border-radius: 3px;
    transition: all 0.2s ease;
  }

  .textarea-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  .dark .textarea-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.12);
  }

  .dark .textarea-scrollbar::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

  .textarea-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.12) transparent;
  }

  .dark .textarea-scrollbar {
    scrollbar-color: rgba(255, 255, 255, 0.12) transparent;
  }
`;

// Chat area specific styles including animations and search highlights
export const chatAreaStyles = `
  .search-highlight-message {
    animation: pulse-highlight 2s infinite;
    box-shadow: 0 0 0 3px rgba(173, 221, 48, 0.7) !important;
    position: relative;
    z-index: 1;
  }
  
  .user-message-time {
    color: rgba(0, 0, 0, 0.7) !important; /* Dark gray that works well on lime green */
  }

  @keyframes pulse-highlight {
    0% { box-shadow: 0 0 0 3px rgba(173, 221, 48, 0.4); }
    70% { box-shadow: 0 0 0 6px rgba(173, 221, 48, 0); }
    100% { box-shadow: 0 0 0 3px rgba(173, 221, 48, 0.4); }
  }

  .search-highlight-active {
    background-color: #ADDD30 !important;
    color: #1D1D1F !important;
    padding: 0 4px !important;
    border-radius: 4px !important;
    font-weight: 600 !important;
    display: inline-block !important;
    margin: 0 2px !important;
    box-shadow: 0 0 0 3px rgba(173, 221, 48, 0.4) !important;
    outline: 2px solid rgba(173, 221, 48, 0.6) !important; 
    position: relative !important;
    z-index: 2 !important;
  }

  .search-highlight, mark {
    background-color: #A076F9 !important;
    color: #ffffff !important;
    padding: 0 3px !important;
    border-radius: 3px !important;
    font-weight: 500 !important;
    display: inline-block !important;
    animation: highlight-pulse 2s infinite !important;
    margin: 0 2px !important;
    box-shadow: 0 0 0 2px rgba(160, 118, 249, 0.4) !important;
    position: relative !important;
    z-index: 1 !important;
  }

  @keyframes highlight-pulse {
    0% { background-color: rgba(160, 118, 249, 0.9); }
    50% { background-color: rgba(144, 99, 205, 0.9); }
    100% { background-color: rgba(160, 118, 249, 0.9); }
  }
  
  .loading-dot {
    display: inline-block;
    opacity: 0;
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
  }
  
  .loading-dot:nth-child(1) {
    animation-name: loadingDot1;
  }
  
  .loading-dot:nth-child(2) {
    animation-name: loadingDot2;
  }
  
  .loading-dot:nth-child(3) {
    animation-name: loadingDot3;
  }
  
  @keyframes loadingDot1 {
    0% { opacity: 0; }
    25% { opacity: 1; }
    50% { opacity: 1; }
    75% { opacity: 0; }
    100% { opacity: 0; }
  }
  
  @keyframes loadingDot2 {
    0% { opacity: 0; }
    25% { opacity: 0; }
    50% { opacity: 1; }
    75% { opacity: 1; }
    100% { opacity: 0; }
  }
  
  @keyframes loadingDot3 {
    0% { opacity: 0; }
    25% { opacity: 0; }
    50% { opacity: 0; }
    75% { opacity: 1; }
    100% { opacity: 1; }
  }

  .dark .search-highlight, .dark mark {
    background-color: #A076F9 !important;
    color: #ffffff !important;
    box-shadow: 0 0 0 2px rgba(160, 118, 249, 0.7) !important;
    text-shadow: none !important;
  }

  .dark .search-highlight-active {
    background-color: #C4F03E !important;
    color: #1D1D1F !important;
    box-shadow: 0 0 0 3px rgba(196, 240, 62, 0.5) !important;
    text-shadow: none !important;
  }

  .bg-[#ADDD30] .search-highlight {
    background-color: #7E22CE !important;
    color: #ffffff !important;
    box-shadow: 0 0 0 2px rgba(126, 34, 206, 0.5) !important;
  }

  .bg-[#ADDD30] .search-highlight-active {
    background-color: #9CC429 !important;
    color: #1D1D1F !important;
    box-shadow: 0 0 0 3px rgba(156, 196, 41, 0.5) !important;
    outline: 2px solid rgba(156, 196, 41, 0.7) !important;
  }
`;

// Inject styles into the document head
export const injectChatAreaStyles = () => {
  if (typeof document !== 'undefined') {
    // Inject scrollbar styles
    const existingScrollbarStyle = document.getElementById('chat-area-scrollbar-styles');
    if (!existingScrollbarStyle) {
      const scrollbarStyle = document.createElement('style');
      scrollbarStyle.id = 'chat-area-scrollbar-styles';
      scrollbarStyle.textContent = chatAreaScrollbarStyles;
      document.head.appendChild(scrollbarStyle);
    }

    // Inject chat area styles
    const existingChatStyle = document.getElementById('chat-area-styles');
    if (!existingChatStyle) {
      const chatStyle = document.createElement('style');
      chatStyle.id = 'chat-area-styles';
      chatStyle.textContent = chatAreaStyles;
      document.head.appendChild(chatStyle);
    }
  }
};